import { useLocalObservable } from 'mobx-react-lite'
import { runInAction } from 'mobx'
import jwt_decode from 'jwt-decode'
import { setAuthToken } from 'lib/utils'
import { useSnackbar } from 'notistack'
import { postLogin } from 'requests/auth'

const initialValues = {
  user: {
    token: '',
    data: {}
  },
  statusId: null,
  statusRequest: [],
  division: null,
  loading: false
}

const AuthContext = () => {
  const { enqueueSnackbar } = useSnackbar()
  const store = useLocalObservable(() => ({
    /*observables*/
    ...initialValues,
    setLoading() {
      runInAction(() => {
        store.loading = !store.loading
      })
    },
    clearAuth() {
      localStorage.clear()
      sessionStorage.clear()
      this.clearStore()
    },
    clearStore() {
      runInAction(() => {
        store.user.token = ''
        store.user.data = {}
      })
    },
    setDivision(division) {
      runInAction(() => {
        store.division = division
      })
    },
    setStatus(status) {
      runInAction(() => {
        store.statusId = status.id
        store.statusRequest = status.request
      })
    },
    setDataToStorage(token, data) {
      setAuthToken(token)
      runInAction(() => {
        store.user.token = token
        store.user.data = data
      })
    },
    setTokenFromQuery(token) {
      if (token && token.length > 10) {
        try {
          const decoded = jwt_decode(token)
          localStorage.setItem('token', token)
          if (token && decoded) {
            this.setDataToStorage(token, decoded)
            return true
          } else {
            enqueueSnackbar('Нет Доступа!', {
              variant: 'error',
              autoHideDuration: 3000
            })
            this.clearAuth()
            return false
          }
        } catch (e) {
          enqueueSnackbar('Что-то пошло не так!', {
            variant: 'error',
            autoHideDuration: 3000
          })
          this.clearAuth()
        }
      }
      return false
    },
    setAuthTokenFromLS() {
      const token = localStorage.getItem('token')
      return this.setTokenFromQuery(token)
    },
    async login(userData) {
      try {
        this.setLoading()
        const res = await postLogin(userData)
        const { token } = res
        const decoded = jwt_decode(token)
        if (token && decoded) {
          localStorage.setItem('token', token)
          this.setDataToStorage(token, decoded)
          enqueueSnackbar('Успешная Авторизация!', {
            variant: 'success',
            autoHideDuration: 3000
          })
          this.setLoading()
          return 0
        } else {
          enqueueSnackbar('Нет Доступа!', {
            variant: 'error',
            autoHideDuration: 3000
          })
          this.clearAuth()
          this.setLoading()
          return 0
        }
      } catch (error) {
        if (error) {
          enqueueSnackbar('Что-то пошло не так! Проверьте логин или пароль', {
            variant: 'error',
            autoHideDuration: 3000
          })
          this.clearAuth()
          this.setLoading()
          return 0
        }
      }
    }
  }))

  return store
}

export default AuthContext
